import { BaseApi } from './base.api.js';

export class AssetGroupCriticalityEvaluationApi extends BaseApi {
    constructor(client) {
        super(client, '/asset-group-criticality-evaluations');
    }

    async assignExperts(assetGroupId, data) {
        const response = await this.client.post(
            `${this.basePath}/asset-groups/${assetGroupId}/assign-experts`,
            data,
        );
        return response.data;
    }

    async startSurvey(id, data) {
        const response = await this.client.post(`${this.basePath}/${id}/start-survey`, data);
        return response.data;
    }

    async getMySurveys() {
        const response = await this.client.get(`${this.basePath}/my-surveys`);
        return response.data;
    }

    async getSurveyDetail(evaluationId) {
        const response = await this.client.get(`${this.basePath}/surveys/${evaluationId}`);
        return response.data;
    }

    async submitSurvey(evaluationId, data) {
        const response = await this.client.post(`${this.basePath}/surveys/${evaluationId}/submit`, data);
        return response.data;
    }

    async getSummary(id) {
        const response = await this.client.get(`${this.basePath}/${id}/summary`);
        return response.data;
    }

    async getEvaluationPreview(id) {
        const response = await this.client.get(`${this.basePath}/${id}/evaluation-preview`);
        return response.data;
    }

    async approve(id, data = {}) {
        const response = await this.client.post(`${this.basePath}/${id}/approve`, data);
        return response.data;
    }

    async repeatSurvey(id) {
        const response = await this.client.post(`${this.basePath}/${id}/repeat-survey`);
        return response.data;
    }

    async restart(id, data) {
        const response = await this.client.post(`${this.basePath}/${id}/restart`, data);
        return response.data;
    }
}
